import {
  DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_BEGIN,
  DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_SUCCESS,
  DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_FAILURE,
  DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';

export function getMySqlDataSourceData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/get-tables`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_FAILURE,
            data: { error: err },
          });
          const { response } = err;
          console.log('🚀 ~ getMySqlDataSourceData ~ error response:', response);
          switch (response.status) {
            case 400: {
              const { error } = response.data ? response.data : '';
              toast.error(`${error} !`);
              break;
            }
            case 500: {
              const { code, errno, message } = response.data ? response.data : '';
              if (['ENOTFOUND', 'ECONNREFUSED'].includes(code)) {
                toast.error(`Unable to connect to MySQL! Please enter valid details.`);
              } else {
                toast.error(`${errno}: ${message} !`);
              }
              break;
            }
            default:
              console.error('🚀 ~ getMySqlDataSourceData ~ error:', err);
              break;
          }

          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetMySqlDataSourceDataError() {
  return {
    type: DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getMySqlDataSourceDataPending: true,
        getMySqlDataSourceDataError: null,
      };

    case DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        getMySqlDataSourceDataPending: false,
        getMySqlDataSourceDataError: null,
        mysqlTables: action.data,
      };

    case DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        getMySqlDataSourceDataPending: false,
        getMySqlDataSourceDataError: action.data.error,
      };

    case DATA_CONNECTOR_GET_MY_SQL_DATA_SOURCE_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getMySqlDataSourceDataError: null,
      };

    default:
      return state;
  }
}
